import { render, staticRenderFns } from "./modalIframe.vue?vue&type=template&id=0fc72cfa&scoped=true"
import script from "./modalIframe.vue?vue&type=script&lang=js"
export * from "./modalIframe.vue?vue&type=script&lang=js"
import style0 from "./modalIframe.vue?vue&type=style&index=0&id=0fc72cfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc72cfa",
  null
  
)

export default component.exports